import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import '@jaymathew/ui-shared/apis/FirebaseUtilities/FirebaseConfig'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as React from 'react'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import Routes from 'routes/routes'

const swCleanupStorageKey = 'rr_sw_decommission_cleanup_v1'

const runServiceWorkerDecommissionCleanup = async () => {
	if (typeof window === 'undefined') return

	try {
		const shouldSkipCleanup = window.localStorage.getItem(swCleanupStorageKey) === '1'
		const registrations = 'serviceWorker' in navigator
			? await navigator.serviceWorker.getRegistrations()
			: []

		if (registrations.length === 0 && shouldSkipCleanup) return

		await Promise.all(registrations.map((registration) => registration.unregister().catch(() => false)))

		if ('caches' in window) {
			const cacheKeys = await caches.keys()
			await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey).catch(() => false)))
		}

		window.localStorage.setItem(swCleanupStorageKey, '1')
	} catch (error) {
		console.warn('Service worker cleanup failed', error)
	}
}

void runServiceWorkerDecommissionCleanup()

// register bugsnag
Bugsnag.start({
	apiKey: 'f0953a9407e1fa3f9ecd7cf483cda61b',
	plugins: [new BugsnagPluginReact()],
	enabledReleaseStages: ['production', 'staging'],
	releaseStage: process.env.REACT_APP_ENV,
	onError: (event) => {
		const errorClass = event.errors[0]?.errorClass?.toLowerCase() || ''
		const errorMessage = event.errors[0]?.errorMessage?.toLowerCase() || ''

		if (errorMessage.includes('does not match our records')) return false
		if (errorMessage.includes('missing information, please enter your email and password before logging in.')) return false
		if (errorMessage.includes('recaptcha has already been rendered in this element')) return false
		if (errorMessage.includes('no recaptcha')) return false
		if (errorClass === 'invaliderror' && errorMessage.includes('unhandledrejection handler received a non-error')) return false
		if (errorClass === 'invalidstateerror' && errorMessage.includes('database connection is closing')) return false

		return true
	},
})
// wrap your entire app tree in the ErrorBoundary provided
const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)

export const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
	<ErrorBoundary>
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<Routes />
			</QueryClientProvider>
		</StrictMode>
	</ErrorBoundary>,
)
